import { SelectOption } from '@navstation-portal/shared/data-model/common';
import { PrimeMoverLabels, VESSEL_TYPES } from '@navstation-portal/vessels/data-model/vessel';

const aePowerUnitMap = {
  kw: 'kW',
  kwhr: 'kWhr',
} as const;

export type VesselTypeMap = Record<string, string>;
export const vesselTypeMap: VesselTypeMap = Object.fromEntries(VESSEL_TYPES.map(({ code, name }) => [code, name]));

export const IceClassNotationMap = {
  null: '-',
  '1A_SUPER': '1A Super',
  '1A': '1A',
  '1B': '1B',
  '1C': '1C',
  PC_1: 'PC(1)',
  PC_2: 'PC(2)',
  PC_3: 'PC(3)',
  PC_4: 'PC(4)',
  PC_5: 'PC(5)',
  PC_6: 'PC(6)',
  PC_7: 'PC(7)',
};

const mrvMethodOptionsMap: Record<string, string> = {
  a: 'Method A: BDN and Periodic Stocktakes of Fuel Tanks',
  b: 'Method B: Bunker Fuel Tank Monitoring On-Board',
  c: 'Method C: Flowmeters for Applicable Combustion Processes',
  d: 'Method A: BDN and Periodic Stocktakes of Fuel Tanks',
};

const imoDCSMethodOptionsMap: Record<string, string> = {
  '1 (Bunker Delivery Notes (BDNs)': 'Method 1: Bunker Delivery Notes (BDNs)',
  '2 (Flow Meters)': 'Method 2: Flow Meters',
  '3 (Bunker Fuel Oil Tank Monitoring On Board)': 'Method 3: Bunker Fuel Oil Tank Monitoring On Board',
  '4 (LNG Cargo Tank Monitoring On Board)': 'Method 4: LNG Cargo Tank Monitoring On Board',
  '5 (Cargo Tank Monitoring On Board For Ships Using Cargo Other Than LNG As A Fuel)':
    'Method 5: Cargo Tank Monitoring On Board For Ships Using Cargo Other Than LNG As A Fuel',
};

export const MapType = {
  aePowerUnit: 'aePowerUnit',
  vesselType: 'vesselType',
  primeMover: 'primeMover',
  iceClass: 'iceClass',
  mrv: 'mrv',
  dcs: 'dcs',
} as const;

export type MapType = keyof typeof MapType;

const MapOptions = {
  [MapType.aePowerUnit]: aePowerUnitMap,
  [MapType.vesselType]: vesselTypeMap,
  [MapType.primeMover]: PrimeMoverLabels,
  [MapType.iceClass]: IceClassNotationMap,
  [MapType.mrv]: mrvMethodOptionsMap,
  [MapType.dcs]: imoDCSMethodOptionsMap,
} as const;

export function getOptionFromMap(lookupValue: string | number | undefined, mapType: MapType): SelectOption {
  const map = MapOptions[mapType];
  const result = map[lookupValue as keyof typeof map];
  if (!result) return { code: null, name: '-' };
  return {
    code: lookupValue,
    name: result,
  };
}
